module.exports = __webpack_public_path__ + "static/media/icon-download.61a3ab3a.svg";